// extracted by mini-css-extract-plugin
module.exports = {"table":"table-3e5Ww","th":"th-2AQri","td":"td-QhHeg","tr--body":"tr--body-24Bl3"};